import React from "react";
import { Grid, Box, Typography, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import KenInput from "../../../../../../GlobalComponents/KenInput";
import { IAssignment } from "../../Assignment/index"
import { DROP_DOWN, QuizConfig } from "../Helper/AssessmentHelper";
import KenSelect from "../../../../../../GlobalComponents/KenSelect";
import { textAlign } from "@mui/system";
interface IGrace {
    data: IAssignment | QuizConfig;
    handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    from: string;
}

const GradeSettings: React.FC<IGrace> = ({ data, handleChange, from }: IGrace) => {
    return (
        <>
            {
                (from == "assign") ?
                    <Box sx={{ p: 2, background: "#F8FAFD", borderRadius: "8px" }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <KenInput
                                    type="number"
                                    label="Total marks"
                                    placeholder="0"
                                    name="grade"
                                    value={(data as IAssignment).grade}
                                    onChange={handleChange}
                                    fullWidth
                                    required
                                />
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <KenInput
                                    type="number"
                                    label="Grade to pass assessment"
                                    placeholder="0"
                                    name="gradepass"
                                    value={(data as IAssignment).gradepass}
                                    onChange={handleChange}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                    </Box> : (
                        <Box sx={{ p: 2, background: "#F8FAFD", borderRadius: "8px" }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={4}>
                                    <Typography style={{ textAlign: "left" }}>Is this assessment graded?</Typography>
                                    <RadioGroup row defaultValue="1">
                                        <FormControlLabel value="1" control={<Radio />} label="Yes" />
                                        <FormControlLabel value="0" control={<Radio />} label="No" />
                                    </RadioGroup>
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <KenInput
                                        type="number"
                                        label="Grade to pass assessment"
                                        placeholder="0"
                                        name="gradetopass"
                                        value={(data as QuizConfig).gradetopass}
                                        onChange={handleChange}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <KenSelect
                                        fullWidth
                                        label="Attempts allowed"
                                        name="attemptallowed"
                                        value={(data as QuizConfig).attemptallowed}
                                        onChange={handleChange}
                                        options={DROP_DOWN.AttemptsAllowed}
                                        sx={{ height: "3rem" }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <KenSelect
                                        fullWidth
                                        label="Grade Methods"
                                        name="grademethod"
                                        value={(data as QuizConfig).grademethod}
                                        onChange={handleChange}
                                        options={DROP_DOWN.GradeMethods}
                                        sx={{ height: "3rem" }}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    )
            }
        </>
    );
};

export default GradeSettings;
